export enum BlueprintItemType {
  AssetType = "ASSET_TYPE",
  QuestionType = "QUESTION_TYPE",
  Property = "PROPERTY",
  Objective = "OBJECTIVE",
  DepthOfKnowledge = "DOK",
  Blooms = "BLOOMS",
  Tag = "TAG",
  InteractionCount = "INTERACTION_COUNT",
  ContextWordCount = "CONTEXT_WORD_COUNT",
  ContextLexile = "CONTEXT_LEXILE",
}

export interface BlueprintItemSubValue {
  key?: string;
  value?: string;
}

export interface BlueprintItem {
  type?: BlueprintItemType;

  /** user-assigned item label */
  label?: string;

  /** operator (equal to, not equal to, etc.) NOT in use yet. */
  op?: string;

  /** select value */
  value?: string;

  /** group name */
  group?: string;

  /** secondary input required */
  secondaryInputType?: "number" | "tag" | "objective" | "string";

  /**
   * secondary values captured within the select element (ex: tag will have an
   * additional `key` and `value` field.) */
  subvalue?: BlueprintItemSubValue;
}

export interface BlueprintConfig {
  boostRequestedCountEnabled?: boolean;
  boostRequestedCountValue?: number;
}

export interface Blueprint {
  specs: BlueprintSpec[];
  config: BlueprintConfig;
}

export interface BlueprintSpec {
  id: string;
  items: BlueprintItem[];
  qty?: number;
  op?: "AND" | "OR";
  specs?: BlueprintSpec[];

  progress?: {
    [key: string]: number;
  };

  /** owners */
  owners?: any;
}
